import axios from 'axios';
import bookReviewsData from '../../data/book_reviews.json';

const API_URL = process.env.REACT_APP_API_URL
const STATIC_WEBSITE = process.env.REACT_APP_STATIC_WEBSITE === 'True'

const BookReviewService = {
    getAllReviews: async () => {
        try {
            if (STATIC_WEBSITE) {
                return bookReviewsData;
            } else {
                const response = await axios.get(`${API_URL}/bookreviews/`);
                return response.data;
            }
        } catch (error) {
            console.error('Error fetching tracks:', error);
            throw error;
        }
    },

    getCount: async () => {
        try {
            if (STATIC_WEBSITE) {
                return bookReviewsData.length;
            } else {
                const response = await axios.get(`${API_URL}/bookreviews/count/`);
                return response.data.count;
            }
        } catch (error) {
            console.error('Error fetching review count:', error);
            throw error;
        }
    }
};

export default BookReviewService;